export const LayoutImage = (models) => {
    let totalElement = [];
    let listElement = [];
    for (let index = 0; index < models.length; index++) {
        var element = models[index];
        if (listElement.length == 0) {
            listElement.push(element);
        } else {
            let last = listElement[listElement.length - 1];
            //nếu trước là ngang
            if (last.orientation == "horizontal") {
                //hiện tại là ngang
                if (element.orientation == "horizontal") {
                    if (listElement.length == 1) {
                        listElement.push(element);
                        totalElement.push(listElement);
                        listElement = [];
                    } else {
                        totalElement.push(listElement);
                        listElement = [element];
                    }
                }
                //hiện tại là dọc
                else {
                    if (listElement.length == 1) {
                        listElement.push(element);
                    } else {
                        totalElement.push(listElement);
                        listElement = [element];
                    }
                }
            }
            //nếu trước là dọc
            else {
                //hiện tại là ngang
                if (element.orientation == "horizontal") {
                    if (listElement.length == 1) {
                        listElement.push(element);
                        totalElement.push(listElement);
                        listElement = [];
                    } else {
                        //trước có ngang hay chưa
                        var existH = listElement.some((x) => x.orientation == "horizontal");
                        if (!existH) {
                            listElement.push(element);
                            totalElement.push(listElement);
                            listElement = [];
                        } else {
                            totalElement.push(listElement);
                            listElement = [element];
                        }
                    }
                }
                //hiện tại là dọc
                else {
                    if (listElement.length == 1) {
                        listElement.push(element);
                    } else {
                        listElement.push(element);
                        totalElement.push(listElement);
                        listElement = [];
                    }
                }
            }
        }
    }

    if (listElement.length > 0) {
        totalElement.push(listElement);
        listElement = [];
    }

    //xử lý flex number từng dòng
    let listFlex = [];
    let row = 1;
    if (totalElement && totalElement.length > 0)
        for (const elements of totalElement) {
            var minH = Math.min(...elements.map((x) => x.height));

            for (var iterator of elements) {
                iterator.width = (iterator.width * minH) / iterator.height;
                iterator.height = minH;
            }

            var totalWidth = elements.reduce((prev, item) => (prev += item.width), 0);
            for (var iterator of elements) {
                iterator.flexNumber = (iterator.width / totalWidth) * 100;
                iterator.row = row;
                listFlex.push(iterator);
            }

            row += 1;
        }

    //gán vào danh sách models và return
    for (var model of models) {
        var item = listFlex.find((x) => x.id == model.id);
        var flexNumber = 0;

        if (!item) {
            flexNumber = model.orientation == "horizontal" ? 50 : 100 / 3;
            model.notYetCompleted = true;
        } else flexNumber = item.flexNumber;
        model.flexNumber = flexNumber;
    }

    //nếu item cuối cùng là 50% thì lấy chia 2
    if (models.length > 0) {
        var lastItem = models[models.length - 1];
        if (lastItem.flexNumber == 100) {
            lastItem.flexNumber = 100 / 2;
        }
    }

    return models;
};



// WEBPACK FOOTER //
// ./src/artist-ui/components/LayoutImage.js